<template>
  <div class="rf-field rf-select" :class="computedClass">

    <!-- Slot for custom label markup -->
    <slot>
      <label :for="name" class="rf-label" v-if="label">{{ label }}</label>
    </slot>

    <slot name="fallback" v-if="!options.length"></slot>

    <div class="rf-select-box">
      <select v-bind="{ name, id: name }" v-model="value" v-validate="validation" :disabled="disabled || !options.length" ref="input" @change="onChange" tabindex="0" :class="{ 'rf-select-has-value': value !== null}">
        <option :value="null" selected v-if="!options.length">No options available</option>
        <option :value="null" selected disabled hidden v-if="placeholder">{{ placeholder }}</option>
        <option is="rf-option" :option="option" :disabled="option.disabled" v-for="option in options"></option>
      </select>
      <transition name="fade-fast">
        <icon name="exclamation-triangle" class="rf-icon rf-icon-invalid" v-if="showInvalid" key="invalid"></icon>
        <icon name="check" class="rf-icon rf-icon-valid" v-else-if="showValid" key="valid"></icon>
      </transition>
      <icon name="caret-down" class="rf-icon rf-caret"></icon>
      <!-- Errors -->
      <rf-message v-if="showInvalid">{{ errors.first(name) }}</rf-message>
    </div>
  </div>
</template>

<script>
import mixins from '@/mixins/index'
import RfOption from '@/components/RfOption'

export default {
  name: 'RfSelect',
  mixins: mixins,
  components: {
    'rf-option': RfOption
  },
  props: {
    placeholder: {
      type: [String, Boolean],
      default: false
    },
    // 0-indexed, so '1' would indicate the 2nd selected option
    selectedOption: {
      type: [Number],
      default: -1
    },
    options: {
      type: Array,
      required: true
    }
  },
  created () {
    // Set field value if selectedOption is passed
    if (this.selectedOption > -1) {
      this.select(this.selectedOption)
    }
  },
  computed: {
    computedClass () {
      return { 'is-invalid': this.showInvalid, 'is-valid': this.showValid, 'is-disabled': this.disabled || !this.options.length }
    },
    flattenedOptions: function () {
      var options = []
      this.options.forEach(function (option) {
        // Remember, all the ||'s are allowing for options to be expressed and simple strings or as objects
        // and if as object, the 'label' and/or 'value' properties may appear by themselves
        if (typeof option === 'string' || typeof option.value === 'string' || typeof option.value === 'undefined') {
          // The order of short-circuit ||'s matters
          options.push({ label: option.label || option.value || option, value: option.value || option.label || option })
        } else if (typeof option.value === 'object') {
          option.value.forEach(function (innerOption) {
            options.push({ label: innerOption.label || innerOption, value: innerOption.value || innerOption })
          })
        }
      })

      return options
    }
  },
  methods: {
    onChange () {
      this.isDirty = true
      // Best I can do. I can't prevent the field from gaining focus, because
      // mousedown triggers the select to open, so I can't just preventDefault
      // on that. If user selects same value again, the field will be focused.
      this.$refs.input.blur()
    },
    select (index) {
      this.value = index > -1 && typeof this.flattenedOptions[index] !== 'undefined'
        ? this.flattenedOptions[index].value || this.flattenedOptions[index]
        : null
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (typeof newVal !== 'undefined' && newVal !== null) {
        this.validate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RfSelect.vue?3d200ad1